export enum scoreCardStatusActions {
  POST_SCORE_CARD_STATUS = "POST_SCORE_CARD_STATUS",
  POST_SCORE_CARD_STATUS_SUCCESS = "POST_SCORE_CARD_STATUS_SUCCESS",
  POST_SCORE_CARD_STATUS_FAILED = "POST_SCORE_CARD_STATUS_FAILED",

  SCORE_CARD_STATUS_VMSB_LIST = "SCORE_CARD_STATUS_VMSB_LIST",
  SCORE_CARD_STATUS_VMSB_LIST_SUCCESS = "SCORE_CARD_STATUS_VMSB_LIST_SUCCESS",
  SCORE_CARD_STATUS_VMSB_LIST_FAILED = "SCORE_CARD_STATUS_VMSB_LIST_FAILED",
}
